module.exports = __webpack_public_path__ + "static/img/wechat.723b2faf.png";